module.exports = __webpack_public_path__ + "img/patients-en-r_carré.2648290.png";